import { useEffect } from 'react';
import { NavEvent } from '../features/nav/NavEvent';
import { pageViewTracker } from '../services/PageViewTracker';

/**
 * React hook for automatic page view tracking
 * Integrates with the existing NavEvent-based navigation system
 * @param {NavEvent} currentPage - The current page being viewed
 */
export function usePageTracking(currentPage: NavEvent): void {
  useEffect(() => {
    // Track page view when the current page changes
    pageViewTracker.trackPageView(currentPage);
  }, [currentPage]);
}

/**
 * React hook for feature usage tracking
 * @param {NavEvent} currentPage - Current page context
 * @param {string} featureName - Name of the feature being used
 * @param {boolean} isActive - Whether the feature is currently active/visible
 */
export function useFeatureTracking(
  currentPage: NavEvent,
  featureName: string,
  isActive = true,
): void {
  useEffect(() => {
    if (isActive) {
      pageViewTracker.trackFeatureUsage(currentPage, featureName);
    }
  }, [currentPage, featureName, isActive]);
}
